import React from 'react';
import { Link } from 'react-router-dom';
import HeroVideoBackground from '../../components/public/HeroVideoBackground';
import HeartIcon from '../../components/common/HeartIcon';
import MissionStatement from '../../components/public/MissionStatement';
import CrisisLifeline from '../../components/public/CrisisLifeline';
import OutreachSection from '../../components/public/OutreachSection';
import DonationWidget from '../../components/public/DonationWidget';
import FeaturedNotesCarousel from '../../components/public/FeaturedNotesCarousel';
import FeaturedStory from '../../components/home/FeaturedStory';
import FeaturedNews from '../../components/home/FeaturedNews';
import '../../styles/HomePage.css';

const HomePage: React.FC = () => {
  return (
    <div className="home-page">
      {/* Hero Section with Video Background */}
      <HeroVideoBackground>
        <section className="hero text-white py-5">
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center mb-5 mb-lg-0">
                <h1 className="display-3 fw-bold mb-2">Write a Note</h1>
                <h2 className="display-3 fw-bold mb-4">Save a Life</h2>
                <p className="lead mb-4">
                  Share your words of encouragement and inspiration with the world.
                  Create a positive impact through the power of uplifting messages.
                </p>
                <div className="d-grid gap-3 d-sm-flex justify-content-center">
                  <Link to="/notes" className="btn btn-light btn-lg px-4">
                    Browse Notes
                  </Link>
                  <Link to="/submit" className="btn btn-outline-light btn-lg px-4">
                    Create a Note
                  </Link>
                </div>

                {/* Donate Button */}
                <div className="hero-donate-container mt-4">
                  <a href="#donate" className="hero-donate-link">
                    <HeartIcon className="me-2" />
                    Support Our Mission
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </HeroVideoBackground>

      {/* How It Works Section */}
      <section className="py-5">
        <div className="container py-5">
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold">How It Works</h2>
            <p className="lead text-muted">Simple steps to spread positivity</p>
          </div>

          <div className="row g-4">
            <div className="col-md-4 text-center mb-4">
              <div className="feature-icon">
                <i className="fas fa-edit fs-1"></i>
              </div>
              <h4>Share Your Story</h4>
              <p className="lead">
                Submit a note about your thoughts, experiences, or observations.
                Your voice matters and can make a difference.
              </p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <div className="feature-icon">
                <i className="fas fa-paper-plane fs-1"></i>
              </div>
              <h4>Reach Your Community</h4>
              <p className="lead">
                Your notes are shared in the community, published in the StampOutSuicide.org newspaper,
                and soon available on screens in local organizations.
              </p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <div className="feature-icon">
                <i className="fas fa-heart fs-1"></i>
              </div>
              <h4>Make an Impact</h4>
              <p className="lead">
                See how your stories resonate with others through hearts and engagement.
                Build community connections one note at a time.
              </p>
            </div>
          </div>

{/* TODO: Add a "Learn More" web page with more information about the project. */}
          <div className="text-center mt-5" style={{display:"none"}}>
            <Link to="/learn-more" className="btn btn-outline-primary btn-lg">
              Learn More
            </Link>
          </div>

          {/* Big Create a Note CTA Button */}
          <div className="text-center mt-5">
            <Link to="/submit" className="btn btn-create-note-cta btn-lg px-5 py-3">
              <i className="fas fa-edit me-2"></i>
              Create a Note
            </Link>
          </div>
        </div>
      </section>

      {/* Featured Notes Carousel */}
      <FeaturedNotesCarousel />

      {/* Featured Stories and News Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-4">
            <div className="col-md-6">
              <FeaturedStory />
            </div>
            <div className="col-md-6">
              <FeaturedNews />
            </div>
          </div>
          <div className="text-center mt-4">
            <Link to="/stories" className="btn btn-outline-primary me-2">
              All Stories
            </Link>
            <Link to="/news" className="btn btn-outline-primary">
              All News
            </Link>
          </div>
        </div>
      </section>

      {/* Mission Statement Section */}
      <MissionStatement />

      {/* Crisis Lifeline Banner */}
      <CrisisLifeline />

      {/* Outreach Section */}
      <OutreachSection />

      {/* Donation Widget Section - Replaces "Our Impact" and CTA */}
      <DonationWidget />
    </div>
  );
};

export default HomePage;
